import DOMPurify from 'dompurify';

export const decodeTitleHTML = (text = '', limit = 0) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = DOMPurify.sanitize(text, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
    const cleanText = txt.value.trim();

    if (typeof limit !== 'number' || !Number.isInteger(limit) || limit < 0) {
        return 'Limit must be a integer or number';
    } else if (limit > 0) {
        return cleanText.length > limit? `${cleanText.substring(0, limit)}…`: cleanText;
    } else {
        return cleanText;
    }
};

